import { OrderCheckInModel } from "./OrderCheckIn.model";

export class OrderCheckIn extends OrderCheckInModel {
    // Add custom methods here
}
